/**
 * AnimatedAccordion — smooth expand/collapse with Framer Motion.
 * Gives a premium feel to FAQ sections, footer dropdowns, and any toggle content.
 *
 * Usage:
 *   <AnimatedAccordion isOpen={open}>
 *     <p>Content that smoothly expands/collapses</p>
 *   </AnimatedAccordion>
 */
import { motion, AnimatePresence } from "framer-motion";

const variants = {
  hidden: { height: 0, opacity: 0 },
  visible: { height: "auto", opacity: 1 },
  exit: { height: 0, opacity: 0 },
};

const transition = {
  height: { type: "spring", stiffness: 300, damping: 30 },
  opacity: { duration: 0.2 },
};

export default function AnimatedAccordion({ isOpen, children, className = "" }) {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          key="accordion-content"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={variants}
          transition={transition}
          className={`overflow-hidden ${className}`}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
